import { useState } from 'react';
import styled from '@emotion/styled';

const Wrapper = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin: 0 0.5rem;
`;

const Switch = styled.div`
  position: relative;
  width: 2.5em;
  height: 1em;
  background: ${(props) => (props.checked ? 'green' : '#b3b3b3')};
  border-radius: 32px;
  padding: 4px;
  transition: 300ms all;

  &:before {
    transition: 300ms all;
    content: '';
    position: absolute;
    width: 1em;
    height: 1em;
    border-radius: 35px;
    top: 50%;
    left: 4px;
    background: white;
    transform: translate(${(props) => (props.checked ? 'calc(2em - 8px)' : 0)}, -50%);
  }
`;
const Input = styled.input`
  display: none;
`;

const ToggleSwitch = ({ checked, onChange }) => {
  return (
    <Wrapper>
      <Input checked={checked} type='checkbox' onChange={onChange} />
      <Switch checked={checked} />
    </Wrapper>
  );
};

export default ToggleSwitch;
